// extracted by mini-css-extract-plugin
module.exports = {"btnBlockWrapper":"PairedBtnBlock_btnBlockWrapper__2wfG-","btnRoot":"PairedBtnBlock_btnRoot__15Tpt","btnSavePrimary":"PairedBtnBlock_btnSavePrimary__161NO"};